import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const MosaicCardInfoContainer = styled.div<{ info: boolean }>`
  border-radius: 0 0 ${Screen.widthRatio * 19}px ${Screen.widthRatio * 19}px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${Screen.widthRatio * 12}px ${Screen.widthRatio * 24}px;
  height: ${Screen.widthRatio * 172}px;
  width: ${Screen.widthRatio * 302}px;
`;

export default MosaicCardInfoContainer;
